import {useCallback, useState} from "react";

import {DEFAULT_DASHBOARD_PERIOD} from "../lib";
import type {DashboardOverviewFilters, DashboardPeriodKey} from "../types";

const DEFAULT_FILTERS: DashboardOverviewFilters = {
  period: DEFAULT_DASHBOARD_PERIOD,
  context_property_ids: [],
};

export default function useDashboardFilters(
  initial: Partial<DashboardOverviewFilters> = {},
) {
  const [filters, setFilters] = useState<DashboardOverviewFilters>({
    ...DEFAULT_FILTERS,
    ...initial,
  });

  const setPeriod = useCallback((period: DashboardPeriodKey) => {
    setFilters((prev) => ({...prev, period}));
  }, []);

  const setContextPropertyIds = useCallback((ids: number[]) => {
    setFilters((prev) => ({...prev, context_property_ids: ids}));
  }, []);

  const reset = useCallback(() => setFilters(DEFAULT_FILTERS), []);

  return {filters, setPeriod, setContextPropertyIds, reset};
}
